export const WX_APP_CONFIG = {
  corpid: process.env.VUE_APP_WX_CORPID,
  agentid: process.env.VUE_APP_WX_AGENTID,
  state: 'WX_LOGIN_STATE',
  scope: 'snsapi_privateinfo',
}
